import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { useTranslation } from 'react-i18next';
import './style.css';
import i18n from 'i18next'; // Add this import if not already
import NotificationBell from 'components/NotificationBell';
import { jsPDF } from 'jspdf';
import { buildGoodDeliveryQuery } from './goodDeliveryConfig';
import Swal from 'sweetalert2';

const OrdersAdmin = () => {
        const { t } = useTranslation();
    const [orders, setOrders] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
const [dateFilter, setDateFilter] = useState(''); // values: '7', '15', '30'
const [searchID, setSearchID] = useState('');    
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [deliveryLoadingId, setDeliveryLoadingId] = useState(null);
      const currentLang = i18n.language; // e.g. 'fr' or 'ar'
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [editingOrder, setEditingOrder] = useState(null);

    useEffect(() => {
      const adminFlag = localStorage.getItem('isAdmin') === '1';
      setIsAdmin(adminFlag);
      if (adminFlag) {
        fetchAllOrders(1);
      }
    }, []);

   useEffect(() => {
    if (!isAdmin) return;

    const interval = setInterval(() => {
fetchAllOrders(currentPage);
    }, 15000); // every 15s

    return () => clearInterval(interval);
}, [isAdmin, currentPage, statusFilter, dateFilter, searchID]);


    const fetchAllOrders = async (page) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            const response = await axios.get(`  https://plateformewmg.cloud/api/admin/orders?page=${page}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
          const data = Array.isArray(response.data.data) ? response.data.data : [];
          setOrders(data);  // Response data with paginated orders
        setTotalPages(response.data.last_page ?? 1);  // Total number of pages
            } else {
                console.error('Failed to fetch orders:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
        }
    };


    const getOrderUniqueId = (order) => String(order?.OrderID ?? order?.idsOrder ?? '');

    useEffect(() => {
      // Remove selections that no longer exist in the current page
      setSelectedOrderIds((prev) => prev.filter((id) => orders.some((order) => getOrderUniqueId(order) === id)));
    }, [orders]);
    const handleStatusChange = async (orderID, newStatus, paymentStatus) => {
      console.log("newStatus",newStatus);
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            const response = await axios.put(
    `  https://plateformewmg.cloud/api/admin/orders/${orderID}/tracking`, 
                { CurrentStatus: newStatus },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 200) {
        fetchAllOrders(currentPage);  // Re-fetch orders after status update
            } else {
                return;
            }
        } catch (error) {
                console.error(error);
        }
    };

    const handlePageChange = (selectedPage) => {
    if (selectedPage < 1 || selectedPage > totalPages) return;
    setCurrentPage(selectedPage);
    };

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
const filteredOrders = orders.filter((order) => {
  const orderStatus = order.Status ?? order.status;
  const matchStatus = statusFilter ? orderStatus === statusFilter : true;

  const matchDate = dateFilter
    ? (() => {
        const orderDate = new Date(order.created_at);
        const today = new Date();
        const pastDate = new Date();
        pastDate.setDate(today.getDate() - parseInt(dateFilter, 10));
        return orderDate >= pastDate && orderDate <= today;
      })()
    : true;

  const searchTerm = searchID.trim();
  const matchSearchID = searchTerm
    ? (order.idsOrder && order.idsOrder.toString().includes(searchTerm)) ||
      (order.supplier?.id && order.supplier.id.toString().includes(searchTerm)) ||
      (order.supplier?.custom_id && order.supplier.custom_id.toString().includes(searchTerm)) ||
      (order.customer_info?.Name && order.customer_info.Name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (order.customer_info?.Phone && order.customer_info.Phone.includes(searchTerm))
    : true;

  return matchStatus && matchDate && matchSearchID;
});

const selectedOrders = orders.filter((order) => selectedOrderIds.includes(getOrderUniqueId(order)));

const allFilteredSelected =
  filteredOrders.length > 0 && filteredOrders.every((order) => selectedOrderIds.includes(getOrderUniqueId(order)));

const toggleOrderSelection = (order) => {
  const orderId = getOrderUniqueId(order);
  setSelectedOrderIds((prev) =>
    prev.includes(orderId) ? prev.filter((id) => id !== orderId) : [...prev, orderId]
  );
};

const toggleSelectAllFiltered = () => {
  if (!filteredOrders.length) return;
  if (allFilteredSelected) {
    const filteredIds = new Set(filteredOrders.map((order) => getOrderUniqueId(order)));
    setSelectedOrderIds((prev) => prev.filter((id) => !filteredIds.has(id)));
  } else {
    const filteredIds = filteredOrders.map((order) => getOrderUniqueId(order));
    setSelectedOrderIds((prev) => Array.from(new Set([...prev, ...filteredIds])));
  }
};

const ensureSelectionOrAlert = () => {
  if (!selectedOrders.length) {
    alert(t('orders_export.no_selection'));
    return false;
  }
  return true;
};

const exportButtonBaseStyle = {
  backgroundColor: '#133b8c',
  color: 'white',
  borderRadius: '25px',
  padding: '8px 20px',
  border: 'none',
  cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(19, 59, 140, 0.4)',
  transition: 'background-color 0.3s ease',
};

const formatCurrency = (amount) => {
  const numericValue = Number(amount);
  return Number.isFinite(numericValue) ? `${numericValue.toFixed(2)} ${t('currency')}` : `0.00 ${t('currency')}`;
};


const resolveLocalizedValue = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value.trim();
  if (Array.isArray(value)) {
    const joined = value.map((item) => resolveLocalizedValue(item)).filter(Boolean).join(' ');
    return joined.trim();
  }
  if (typeof value === 'object') {
    const langVariants = [currentLang, currentLang?.split('-')?.[0], 'fr', 'ar', 'en', 'default'];
    for (const key of langVariants) {
      if (!key) continue;
      const candidate = value[key];
      const resolved = resolveLocalizedValue(candidate);
      if (resolved) return resolved;
    }
    for (const candidate of Object.values(value)) {
      const resolved = resolveLocalizedValue(candidate);
      if (resolved) return resolved;
    }
  }
  return '';
};

const resolveProductName = (product) => {
  if (!product || typeof product !== 'object') return '';
  const sourceCandidates = [
    product.Name,
    product.name,
    product.Title,
    product.title,
    product.ProductName,
    product.productName,
    product.description?.name,
    product.translations?.name,
  ];

  for (const candidate of sourceCandidates) {
    const resolved = resolveLocalizedValue(candidate);
    if (resolved) return resolved;
  }

  return '';
};

const buildProductSummary = (order) => {
  const summary = order.order_items?.map((item) => {
    const name = resolveProductName(item.product) || t('Produit', 'Produit');
    return `${name} (x${item.Quantity || 0})`;
  }) || [];
  return summary.join('; ');
};

const buildProductNames = (order) => {
  const names = order.order_items?.map((item) => {
    const name = resolveProductName(item.product) || t('Produit', 'Produit');
    return name;
  }) || [];
  return names.filter(Boolean).join(', ');
};

const buildTotalQuantity = (order) => {
  return (order.order_items || []).reduce((acc, item) => acc + Number(item.Quantity ?? 0), 0);
};

const handleExportSelectedToCsv = () => {
  if (!ensureSelectionOrAlert()) return;

  const headers = [
    'Order ID',
    'Supplier',
    'Client',
    'Phone',
    'Address',
    'Status',
    'Payment Status',
    'Gain',
    'Amount',
    'Created At',
    'Products',
  ];

  const rows = selectedOrders.map((order) => {
    const supplierName = order.supplier?.name || '';
    const customerName = order.customer_info?.Name || '';
    const phone = order.customer_info?.Phone || '';
    const address = order.customer_info?.Address || '';
    const values = [
      order.idsOrder ?? order.OrderID ?? '',
      supplierName,
      customerName,
      phone,
      address,
      order.Status || order.status || '',
      order.payment?.PaymentStatus || '',
      order.gain || '',
      order.payment?.Amount || '',
      order.created_at ? new Date(order.created_at).toLocaleString() : '',
      buildProductSummary(order),
    ];

    return values
      .map((value) => {
        const str = value === undefined || value === null ? '' : String(value);
        const escaped = str.replace(/"/g, '""');
        return `"${escaped}"`;
      })
      .join(',');
  });

  const csvContent = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `orders-export-${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const handleExportSelectedToPdf = () => {
  if (!ensureSelectionOrAlert()) return;
  const doc = new jsPDF();

  selectedOrders.forEach((order, index) => {
    if (index > 0) doc.addPage();
    let cursorY = 20;

    doc.setFontSize(16);
    doc.text(`${t('ID_de_commande')}: ${order.idsOrder ?? order.OrderID ?? ''}`, 14, cursorY);
    cursorY += 10;

    doc.setFontSize(12);
    doc.text(`${t('Fournisseur')}: ${order.supplier?.name || ''}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Client')}: ${order.customer_info?.Name || ''}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Numéro_de_Téléphone')}: ${order.customer_info?.Phone || ''}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Adresse')}: ${order.customer_info?.Address || ''}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Created_at')}: ${order.created_at ? new Date(order.created_at).toLocaleString() : ''}`, 14, cursorY);
    cursorY += 10;

    doc.text(`${t('statut')}: ${order.Status || order.status || ''}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Statut_Paiement')}: ${order.payment?.PaymentStatus || ''}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Gain')}: ${formatCurrency(order.gain)}`, 14, cursorY);
    cursorY += 6;
    doc.text(`${t('Montant')}: ${formatCurrency(order.payment?.Amount)}`, 14, cursorY);
    cursorY += 10;

    doc.text(t('Produits'), 14, cursorY);
    cursorY += 8;

    const items = order.order_items || [];
    if (!items.length) {
      doc.text(t('No_announcements') || 'N/A', 14, cursorY);
      cursorY += 6;
    } else {
      items.forEach((item, idx) => {
        const name =
          item.product?.Name?.[currentLang] || item.product?.Name?.fr || item.product?.Name?.ar || '';
        const priceAmount = Number(item.Price);
        const formattedPrice = Number.isFinite(priceAmount)
          ? `${priceAmount.toFixed(2)} ${t('currency')}`
          : `0.00 ${t('currency')}`;
        doc.text(`${idx + 1}. ${name} x${item.Quantity || 0} - ${formattedPrice}`, 14, cursorY);
        cursorY += 6;
      });
    }
  });

  doc.save(`orders-export-${new Date().toISOString().slice(0, 10)}.pdf`);
};

const handleSendToDelivery = async (order) => {
  if (!order) {
    return;
  }

  const orderId = getOrderUniqueId(order);
  const customer = order.customer_info || {};
  const fullname = (customer.Name || '').trim();
  const phone = (customer.Phone || '').trim();
  const city = (customer.City || customer.city || '').trim();
  const address = (customer.Address || '').trim();
  const note = (order.notes ||'').trim();
  const priceValue = Number(order.payment?.Amount ?? 0);
  const price = Number.isFinite(priceValue) ? priceValue.toFixed(2) : '0';
  const productsTitle = buildProductNames(order) || 'Commande WMG';
  const totalQuantity = buildTotalQuantity(order) || 1;

  if (!fullname || !phone || !city || !address) {
    alert('Informations client incomplètes pour l\'export vers GoodDelivery.');
    return;
  }

  const query = buildGoodDeliveryQuery({
    fullname,
    phone,
    city,
    address,
    price,
    product: productsTitle,
    qty: String(totalQuantity),
    note,
    change: '0',
    openpackage: '1',
  });

  const url = `https://gooddelivery.ma/addcolis.php?${query}`;

  try {
    setDeliveryLoadingId(orderId);
    const response = await fetch(url, {
      method: 'GET',
      mode: 'no-cors',
    });

    if (!response || response.type === 'opaque') {
      console.info('GoodDelivery response is opaque due to no-cors mode. Assuming success.');
Swal.fire({
  icon: 'success',
  title: 'Succès',
  text: 'Commande envoyée à GoodDelivery',
});
    } else if (response.ok) {
      alert('Commande envoyée à GoodDelivery.');
    } else {
      throw new Error(`Réponse inattendue: ${response.status}`);
    }
  } catch (error) {
    console.error("Erreur lors de l'envoi à GoodDelivery:", error);
    const popup = window.open(url, '_blank', 'noopener,noreferrer');
    if (popup) {
      popup.focus();
      alert("La requête a été ouverte dans un nouvel onglet à cause d'une restriction CORS.");
    } else {
      alert("Échec de l'export vers le transporteur. Veuillez réessayer ou contacter le support.");
    }
  } finally {
    setDeliveryLoadingId((current) => (current === orderId ? null : current));
  }
};
const handleDeleteOrder = async (orderID, status) => {
  if (!status) {
    console.log("Status is undefined, cannot delete");
    return;
  }
  
  const normalizedStatus = status
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  if (normalizedStatus === 'livre' || normalizedStatus === 'annule') {
    console.log("Cannot delete because status is:", normalizedStatus);
    return;
  }

  const confirmDelete = window.confirm("étes-vous sur de vouloir supprimer cette commande ?");
  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    const response = await axios.delete(`https://plateformewmg.cloud/api/admin/orders/${orderID}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      alert("Commande supprimée avec succès.");
      fetchAllOrders(currentPage);
    } else {
      alert("Échec de la suppression de la commande.");
    }
  } catch (error) {
    console.error("Erreur lors de la suppression :", error);
    alert("Une erreur s'est produite.");
  }
};
const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditingOrder(prev => ({ ...prev, [name]: value }));
};

const updateItemQuantity = (index, newQty) => {
    const newItems = [...editingOrder.items];
    newItems[index].Quantity = parseInt(newQty) || 1;
    setEditingOrder({ ...editingOrder, items: newItems });
};

const removeItem = (index) => {
    const newItems = editingOrder.items.filter((_, i) => i !== index);
    setEditingOrder({ ...editingOrder, items: newItems });
};

const submitEdit = async () => {
    try {
        const token = localStorage.getItem('authToken');
        
        // Show loading state
        Swal.fire({
            title: 'Chargement...',
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false
        });

        await axios.put(`https://plateformewmg.cloud/api/admin/orders/${editingOrder.OrderID}`, editingOrder, {
            headers: { Authorization: `Bearer ${token}` }
        });

        // Success Toast (Modern Minimalist Style)
        Swal.fire({
            icon: 'success',
            title: 'Modifié avec succès',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });

        setIsEditModalOpen(false);
        fetchAllOrders(currentPage);
    } catch (error) {
        console.error(error);
        Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de la modification.',
            confirmButtonColor: '#6a9739', // Matches your brand green
        });
    }
};
const hasSupplierOrders = orders.some(order => order.SupplierID !== null);

    return (
        <AnimationRevealPage>
            <LightAdmin />
                                                      <NotificationBell />
            
            <div className="d-flex">
                <section className="w-100 p-3">
<div className="d-flex flex-wrap align-items-center justify-content-center mb-4 gap-4">

    <h1 className="text-dark display-5 w-100 text-center mb-3">
      {t('Tableau_de_bord_commandes')}
    </h1>

    <div className="d-flex flex-wrap align-items-center gap-3 justify-content-center">

      <div className="d-flex flex-column">
        <label className="form-label fw-bold text-dark mb-1 text-center">
          {t('Filtrer_par_statut')}
        </label>
        <select
          className="form-select border-dark shadow-sm"
          style={{ minWidth: '180px', maxWidth: '220px' }}
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">{t('Tous_les_statuts')}</option>
          <option value="en attente">{t('en_attente')}</option>
          <option value="attribué">{t('attribué')}</option>
          <option value="en transit">{t('en_transit')}</option>
          <option value="livré">{t('livré')}</option>
          <option value="annulé">{t('annulé')}</option>
        </select>
      </div>

      <div className="d-flex flex-column">
        <label className="form-label fw-bold text-dark mb-1 text-center">
          {t('Filtrer_par_date')}
        </label>
        <select
          className="form-select border-dark shadow-sm"
          style={{ minWidth: '180px', maxWidth: '220px' }}
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
        >
          <option value="">{t('Toutes_les_dates')}</option>
          <option value="7">{t('7_derniers_jours')}</option>
          <option value="15">{t('15_derniers_jours')}</option>
          <option value="30">{t('30_derniers_jours')}</option>
        </select>
      </div>

      <div className="d-flex flex-column">
        <label className="form-label fw-bold text-dark mb-1 text-center">
          {t('Recherche_par_ID')}
        </label>
        <input
          type="text"
          className="form-control border-dark shadow-sm"
          style={{ minWidth: '180px', maxWidth: '220px' }}
  placeholder={t('Recherche_par_ID_nom_ou_téléphone')} // Update placeholder to reflect new search options
          value={searchID}
          onChange={(e) => setSearchID(e.target.value)}
        />
      </div>

      <div className="d-flex align-items-end">
        <button
          className="btn"
          onClick={() => {
            setStatusFilter('');
            setDateFilter('');
            setSearchID('');
          }}
          style={{
            height: '38px',
            backgroundColor: '#133b8c',
            color: 'white',
            borderRadius: '25px',
            padding: '0 20px',
            border: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            marginTop: '30px'
          }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = '#133b8c'}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = '#133b8c'}
        >
          {t('Reinitialiser_les_filtres')}
        </button>
      </div>

    </div>
    <div className="d-flex flex-wrap justify-content-center gap-3 mt-3 w-100">
      <button
        type="button"
        className="btn"
        style={{
          ...exportButtonBaseStyle,
          opacity: selectedOrderIds.length ? 1 : 0.6,
          cursor: selectedOrderIds.length ? 'pointer' : 'not-allowed',
        }}
        disabled={!selectedOrderIds.length}
        onClick={handleExportSelectedToCsv}
        onMouseEnter={(e) => { if (selectedOrderIds.length) e.currentTarget.style.backgroundColor = '#0f2b66'; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#133b8c'; }}
      >
        {t('orders_export.export_csv')}
      </button>
      <button
        type="button"
        className="btn"
        style={{
          ...exportButtonBaseStyle,
          opacity: selectedOrderIds.length ? 1 : 0.6,
          cursor: selectedOrderIds.length ? 'pointer' : 'not-allowed',
        }}
        disabled={!selectedOrderIds.length}
        onClick={handleExportSelectedToPdf}
        onMouseEnter={(e) => { if (selectedOrderIds.length) e.currentTarget.style.backgroundColor = '#0f2b66'; }}
        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#133b8c'; }}
      >
        {t('orders_export.export_pdf')}
      </button>
    </div>
  </div>
                <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th style={{ width: '40px' }}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        onChange={toggleSelectAllFiltered}
                                        checked={allFilteredSelected && filteredOrders.length > 0}
                                      />
                                    </th>
                                    <th> {t('ID_de_commande')}</th>
                                    <th> {t('Fournisseur')}</th>
                                    <th> {t('Client')}</th>
                                    <th>{t('Statut_du_paiement')}</th>
                                    <th> {t('Produits')}</th>
                                    <th> {t('Montant')}</th>
{hasSupplierOrders && <th>{t('Gain')}</th>}                                 
                                    <th> {t('Notes')}</th>
                                     <th> {t('created_at')}</th>
                                    <th> {t('statut')}</th>
                                    <th> {t('Actions')}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredOrders.map((order) => {
                                    const orderId = getOrderUniqueId(order);
                                    const isSelected = selectedOrderIds.includes(orderId);
                                    const normalizedStatus = (order.Status ?? order.status ?? '')
  ?.normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLowerCase()
  .trim();

const isDeletable =
  normalizedStatus !== 'livre' &&
  normalizedStatus !== 'annule' &&
  normalizedStatus !== 'pas_de_reponse' &&
  normalizedStatus !== 'reporte';

  const supplierName = order.supplier?.name || t('Commandes_sans_code_promo');
  const supplierCode = order.supplier?.custom_id || '';
  const customerName = order.customer_info?.Name || '';
  const customerPhone = order.customer_info?.Phone || '';
  const customerAddress = order.customer_info?.Address || '';
  const customerCity = order.customer_info?.City || order.customer_info?.city || '';
  const paymentStatus = order.payment?.PaymentStatus || '';
  const orderItems = Array.isArray(order.order_items) ? order.order_items : [];
  const amountDisplay = formatCurrency(order.payment?.Amount);
  const gainDisplay = formatCurrency(order.gain);
  const createdAtDisplay = order.created_at ? new Date(order.created_at).toLocaleString() : '';
  const orderStatus = order.Status ?? order.status ?? '';

  return (

                                    <tr key={orderId || order.OrderID}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isSelected}
                                            onChange={() => toggleOrderSelection(order)}
                                          />
                                        </td>
                                        <td>{order.idsOrder ?? order.OrderID ?? ''}</td>
<td>
  {supplierName}<br />
  <small className="text-muted"> {supplierCode}</small>
</td>
<td>
  {customerName}&nbsp;<br/>
  <a href={`tel:${customerPhone}`} style={{color: 'blue', textDecoration: 'underline'}}>
    {customerPhone}<br/>
  </a>&nbsp;
  {customerAddress}
  {customerCity && (
    <>
      <br />
      <span className="text-muted">{customerCity}</span>
    </>
  )}
</td>
                                        <td>{paymentStatus}</td>
                                        <td>
  {orderItems.map((item) => (
    <div key={item.OrderItemID}>
      {resolveProductName(item.product) || t('Produit', 'Produit')} <br/>(x{item.Quantity})
    </div>
  ))}
</td>

                                        <td>{amountDisplay}</td>
{hasSupplierOrders && (
            <td>
{order.SupplierID ? `${gainDisplay}` : "-"}            </td>
          )}  
                                        <td>{order.notes || ''}</td>
                                        <td>{createdAtDisplay}</td>

                                        <td>
                                            <select
                                                value={orderStatus}
                                                onChange={(e) => handleStatusChange(order.OrderID, e.target.value, paymentStatus)}
                                                className="form-control"
                                                disabled={orderStatus === 'livré' || orderStatus === 'annulé'}
                                            >
                                               <option value="en attente">{t('en_attente')}</option>
<option value="en transit">{t('en_transit')}</option>
<option value="reporte">{t('reporte')}</option>
<option value="pas_de_reponse">{t('pas_de_reponse')}</option>
<option value="livré">{t('livré')}</option>
<option value="annulé">{t('annulé')}</option>

                                            </select>
                                      </td>
                                    <td>
  <div className="d-flex gap-2">
<button 
    className="btn btn-sm btn-primary" 
    onClick={() => {
        // Fix: Use underscores to match your data structure (customer_info / order_items)
        setEditingOrder({
            OrderID: order.OrderID,
            Name: order.customer_info?.Name || '', 
            Phone: order.customer_info?.Phone || '',
            Address: order.customer_info?.Address || '',
            City: order.customer_info?.city || '',
            notes: order.notes || '',
            TotalAmount: order.payment?.Amount || 0,
         items: order.order_items.map(item => ({
  ProductID: item.ProductID,
  product: item.product, // ✅ keep full object
  Quantity: item.Quantity,
  Price: item.Price
}))
        });
        setIsEditModalOpen(true);
    }}
>
    <i className="fas fa-edit"></i>
</button>
    <button
      className="btn btn-sm"
      style={{ backgroundColor: '#edbf03', color: 'white' }}
      disabled={deliveryLoadingId === orderId}
      onClick={() => handleSendToDelivery(order)}
    >
      {deliveryLoadingId === orderId ? t('En_cours') : t('orders.send_to_delivery', 'Envoyer à GoodDelivery')}
    </button>
    <button
      className="btn btn-sm"
      style={{ backgroundColor: 'red', color: 'white' }}
      disabled={!isDeletable}
      onClick={() => handleDeleteOrder(order.OrderID, orderStatus)}
      title="Supprimer"
    >
      <i className="fas fa-trash"></i>
    </button>
  </div>
</td>



                                    </tr>
 );
})}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                <li className="page-item" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                    <button className="page-link"> {t('Previous')}</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className="page-item" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <button className="page-link"> {t('Next')}</button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    {/* Admin Instructions */}
                    <div className="alert alert-info mt-4"
    style={{ backgroundColor: '#133b8c' }}
    >
                        <h5 style={{color:"white"}}>Instructions pour l'admin :</h5>
                        <ul style={{color:"white"}}>
                            <li>Une commande ne peut pas être marquée comme "Livré" si le paiement est "not payé".</li>
                            <li>Le bouton "Modifier" est désactivé tant que la commande n'est pas "Livré".</li>
                        </ul>
                    </div>
                </section>
            </div>
            <Footer />
{isEditModalOpen && editingOrder && (
    <div className="custom-modal-overlay">
        <div className="custom-modal-content">
            <h3 className="mb-4 border-bottom pb-2">Modifier Commande #{editingOrder.OrderID}</h3>
            
            <div className="row">
                <div className="col-md-6">
                    <label>Nom Client</label>
                    <input className="form-control" name="Name" value={editingOrder.Name} onChange={handleEditInputChange} />
                </div>
                <div className="col-md-6">
                    <label>Téléphone</label>
                    <input className="form-control" name="Phone" value={editingOrder.Phone} onChange={handleEditInputChange} />
                </div>
                <div className="col-md-6">
                    <label>Adresse</label>
                    <input className="form-control" name="Address" value={editingOrder.Address} onChange={handleEditInputChange} />
                </div>
                <div className="col-md-6">
                    <label>Ville</label>
                    {/* Fixed: Use City (Capitalized) to match your state logic */}
                    <input className="form-control" name="City" value={editingOrder.City} onChange={handleEditInputChange} />
                </div>
            </div>

            <h5 className="mt-4 mb-3">Produits</h5>
            <div className="product-list-container">
                {editingOrder.items && editingOrder.items.length > 0 ? (
                    editingOrder.items.map((item, index) => (
                        <div key={index} className="d-flex gap-3 align-items-center product-item-row">
<span>{resolveProductName(item.product)}</span>
                            <div className="d-flex align-items-center gap-2">
                                <label className="mb-0 small">Qty:</label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    style={{ width: '80px' }}
                                    value={item.Quantity} 
                                    onChange={(e) => updateItemQuantity(index, e.target.value)} 
                                />
                            </div>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => removeItem(index)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="text-muted italic">Aucun produit dans cette commande.</p>
                )}
            </div>

            <div className="mt-4 row">
                <div className="col-md-6">
                    <label>Total de la commande ({t('currency')})</label>
                    <input 
                        type="number" 
                        className="form-control fw-bold" 
                        style={{ backgroundColor: '#f0fdf4' }} // Light green tint
                        name="TotalAmount" 
                        value={editingOrder.TotalAmount} 
                        onChange={handleEditInputChange} 
                    />
                </div>
            </div>

            <div className="mt-3">
                <label>Notes</label>
                <textarea 
                    className="form-control" 
                    name="notes" 
                    rows="3"
                    placeholder="Ajouter une note..."
                    value={editingOrder.notes} 
                    onChange={handleEditInputChange}
                ></textarea>
            </div>

            <div className="d-flex justify-content-end gap-3 mt-5 pt-3 border-top">
                <button className="btn btn-light px-4" onClick={() => setIsEditModalOpen(false)}>Annuler</button>
                <button className="btn btn-success px-4" onClick={submitEdit}>Enregistrer les modifications</button>
            </div>
        </div>
    </div>
)}        
        </AnimationRevealPage>
    );
};

export default OrdersAdmin;
